import axios from "axios";

export default defineNuxtPlugin((nuxtApp) => {
    let api = axios.create({
        baseUrl: "//" + window.location.host,
        headers: {
            common: {}
        }
    });

    api.interceptors.response.use(
        // check newest app version to handle browser cache warnings
        function (response) {
            const amosweb_version = response.headers['amosweb-version']

            // if (!!amosweb_version && amosweb_version !== context.store.state.registration.remoteVersion && response.config.method === 'get') {
            //     context.store.commit('registration/setRemoteVersion', amosweb_version)
            // }

            return Promise.resolve(response)
        }
    );

    nuxtApp.vueApp.provide('axios', api);

    return {
        provide: {
            axios: api
        }
    };
});